// dnd-kit focuses the dragged item on drop, leaving a focus ring on a row the user reached with the mouse.
export const blurActiveElement = () => {
  if (!(document.activeElement instanceof HTMLElement)) {
    return;
  }

  document.activeElement.blur();
};
